import { sha256 } from '../../hash'
import { getFacebookFbc, getFacebookFbp } from '../facebook/facebook'

declare global {
  interface Window {
    dataLayer: unknown[] | undefined
  }
}

export interface UserData {
  email?: string
  [key: string]: unknown
}

export interface GTMData {
  event: string
  userData?: UserData
  fbp?: string
  [key: string]: unknown
}

export const trackGTMEvent = async ({
  userData,
  ...data
}: GTMData): Promise<void> => {
  window.dataLayer = window.dataLayer || []

  let hashedEmail

  if (userData?.email) {
    hashedEmail = await sha256(userData.email)
  }

  const eventData = {
    ...data,
    userData: {
      ...userData,
      email: hashedEmail,
      fbp: getFacebookFbp(),
      fbc: getFacebookFbc(),
    },
  }

  window.dataLayer.push(eventData)
}
